module.exports = __webpack_public_path__ + "img/Technischer_Zug_mit_FGr_Infrastruktur.01b716d4.svg";